import React, { useEffect, useState } from "react"

import {
  RevolvingContainer,
  RevolvingMainTitle,
  RotatingText,
} from "./revolving-text.styles"

const RevolvingText = ({
  title,
  textArr = [
    "Get hired.",
    "Get promoted.",
    "Be your own boss.",
    "Build your dream career.",
  ],
}) => {
  const [count, setCount] = useState(0)

  useEffect(() => {
    const interval = setInterval(() => {
      setCount((prev) => (prev + 1) % textArr.length)
    }, 2500)

    return () => {
      clearInterval(interval)
    }
  })

  return (
    <RevolvingContainer>
      <RevolvingMainTitle>{title}</RevolvingMainTitle>
      {textArr.map((text, id) => {
        if (text.length > 25)
          throw new Error("Revolving strapline text length should be less than 25 characters")
        return (
          <RotatingText className={count === id ? "active" : ""}>
            {text}
          </RotatingText>
        )
      })}
    </RevolvingContainer>
  )
}

export default RevolvingText
